<template>
  <section :class="className">
    <div class="v-section__header">
      <VIcon v-if="showBack" class="v-section__back" icon="ChevronLeft" :size="20" @click="clickBack" />
      <div v-if="title || $slots.title" class="v-section__header-title">
        <slot name="title">
          <h1>{{ title }}</h1>
        </slot>
      </div>

      <div class="v-section__header-left">
        <slot name="header-left" />
      </div>

      <div class="v-section__header-right">
        <slot name="header-right" />
      </div>
    </div>

    <slot />
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { useClassName } from '../composables/useClassName.ts'
import VIcon from './Icon/VIcon.vue'

interface Props {
  title?: string
  showBack?: boolean
  router?: boolean
  route?: string | object
  fallbackRoute?: string | object
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  showBack: false,
  router: false,
  route: undefined,
  fallbackRoute: undefined,
})

const emit = defineEmits<{
  back: []
}>()

defineSlots<{
  title?(): any
  default?(): any
  'header-left'?(): any
  'header-right'?(): any
}>()

const className = useClassName(
  'v-section',
  computed(() => [props.title]),
)

const $router = useRouter()

function clickBack() {
  emit('back')
  if (props.router || props.route || props.fallbackRoute) {
    if (props.route) {
      $router.replace(props.route)
    } else if (Number($router.options.history.state.position ?? 0) > 1) {
      $router.go(-1)
    } else if (props.fallbackRoute) {
      $router.replace(props.fallbackRoute)
    }
  }
}
</script>

<style>
.v-section {
  position: relative;
}

.v-section__back {
  margin-left: -30px;
  margin-right: 10px;
  cursor: pointer;
  transition: opacity var(--transition);

  &:hover {
    opacity: 0.5;
  }
}

.v-section__header {
  position: relative;
  margin-bottom: 30px;
  display: flex;
  align-items: center;

  h1 {
    display: inline-block;
    margin-bottom: 0;
    outline: none;
  }
}

.v-section__header-title {
  display: flex;
  align-items: center;
  padding-right: 15px;
  overflow-wrap: anywhere;
}

.v-section__header-left {
  flex-grow: 1;
}

.v-section__header-right {
  display: flex;
  flex-shrink: 0;
}
</style>
